import { useEffect, useRef } from "react";

export function useOutsideClick(handler: any) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClick(event: MouseEvent) {
      const target = event.target as HTMLElement;
      if (target?.closest?.("[data-radix-popper-content-wrapper]")) {
        return;
      }
      if (ref.current && !ref.current.contains(target)) {
        handler();
      }
    }

    document.addEventListener("click", handleClick, true);

    return () => {
      document.removeEventListener("click", handleClick, true);
    };
  }, [handler]);

  return ref;
}
